import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
}
const superagentApi = new SuperagentApi({
  baseUrl: window.VUE_APP_SECOND_SERVER || 'http://portal-shimen.code.wiz.top:7310',
})
export default class SecondService {
  // 获取试题
  static async getPaperQuestions(payload) {
    const [err, res] = await superagentApi.get('/api/exam/questions', {
      params: payload,
      headers,
    })
    return [err, res]
  }
}
